export const MIN_SEARCH_CHAR_PATIENT_NAME = 3;
export const MIN_SEARCH_CHAR_PHONE_NUMBER = 5;
export const MIN_SEARCH_CHAR_DATE_OF_BIRTH = 10;
